import { render, staticRenderFns } from "./imgN.vue?vue&type=template&id=d2f3bea2"
var script = {}


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src4020427597/src/jobbliss-app-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('d2f3bea2')) {
      api.createRecord('d2f3bea2', component.options)
    } else {
      api.reload('d2f3bea2', component.options)
    }
    module.hot.accept("./imgN.vue?vue&type=template&id=d2f3bea2", function () {
      api.rerender('d2f3bea2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/icons/staffCardPlaceholders/imgN.vue"
export default component.exports